import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { PageHero } from "@/components/site/PageHero";
import { ItemCard } from "@/components/site/ItemCard";
import { CategoryTabs } from "@/components/site/CategoryTabs";
import { BRAND } from "@/lib/content";

const META = {
  R: { eyebrow: "12 opções numeradas", title: "Tratamento de Ruídos", desc: "Diagnóstico e tratamento de ruídos, vibrações e reverberações. Selecione uma ou várias áreas.", testid: "page-ruidos" },
  I: { eyebrow: "9 níveis", title: "Isolamento Termoacústico por Níveis", desc: "Selecione os níveis desejados ou escolha o pacote de isolamento termoacústico completo.", testid: "page-isolamento" },
  D: { eyebrow: "Diagnóstico por problema", title: "Qual é o seu problema?", desc: "Selecione o problema percebido no veículo. Cada opção indica os serviços previstos para o tratamento.", testid: "page-diagnostico" },
};

export default function CatalogPage({ group }) {
  const { config, sel, toggle } = useApp();
  const m = META[group];
  const items = (config?.items || []).filter((i) => i.group === group);
  return (
    <div data-testid={m.testid}>
      <PageHero eyebrow={m.eyebrow} title={m.title}>{m.desc}</PageHero>
      <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 md:py-16">
        <CategoryTabs />
        <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
          <p className="text-sm text-slate-400">Preços cadastrados pelo prestador. Itens sem preço aparecem como <b className="text-slate-200">sob consulta</b>.</p>
          <a href={BRAND.fabricantesUrl} target="_blank" rel="noreferrer" data-testid="link-fabricantes" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-red-400 hover:text-red-300">
            Consulta de serviços por fabricante <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it) => <ItemCard key={it.key} item={it} selected={sel.includes(it.key)} onToggle={toggle} />)}
        </div>
        {group === "I" && (
          <Link to="/pacotes" className="btn-line mt-10" data-testid="link-pacote-isolamento">Ver isolamento termoacústico completo <ArrowRight className="h-4 w-4" /></Link>
        )}
        {group === "D" && (
          <div className="mt-12 flex flex-col items-start gap-4 border border-red-900/50 bg-red-950/20 p-8 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="font-heading text-xl font-bold uppercase text-white">Barulho difícil de encontrar?</p>
              <p className="text-sm text-slate-400">Contrate o Dr. Ruídos para investigação das possíveis causas do problema.</p>
            </div>
            <Link to="/dr-ruidos" className="btn-red" data-testid="cta-dr-ruidos">Dr. Ruídos <ArrowRight className="h-4 w-4" /></Link>
          </div>
        )}
      </section>
    </div>
  );
}
